function updateBorders() {
  const container = document.querySelector('.new-grid');
  if (!container) return;

  const items = Array.from(container.querySelectorAll('.logo-bar__item'));
  if (items.length === 0) return;

  const rowTops = new Map();

  // Reset borders
  items.forEach(item => {
    item.style.borderRight = '1px solid #dbdbdb';
    item.style.borderBottom = '1px solid #dbdbdb';
  });

  // Detect filas por offsetTop
  items.forEach((item) => {
    const top = item.offsetTop;
    if (!rowTops.has(top)) {
      rowTops.set(top, []);
    }
    rowTops.get(top).push(item);
  });

  // Quitar borde derecho al último de cada fila
  rowTops.forEach(rowItems => {
    const lastItem = rowItems[rowItems.length - 1];
    lastItem.style.borderRight = 'none';
  });

  // Quitar borde inferior a los de la última fila
  const allRows = Array.from(rowTops.values());
  const lastRowItems = allRows.pop();

  if (lastRowItems && lastRowItems.length) {
    lastRowItems.forEach(item => {
      item.style.borderBottom = 'none';
    });
  }
}

// Ejecutar al cargar y al redimensionar
window.addEventListener('DOMContentLoaded', updateBorders);
window.addEventListener('resize', updateBorders);

/* Home */
$(document).ready(function(){
  var current_lang = jQuery('html').attr('lang');
  var pre_lang = '';
  if(current_lang != 'es')
  {
    if (current_lang.includes('-')) {
      current_lang = current_lang.split('-')[0];
    }
    pre_lang = '/'+current_lang;
  }
  $('#CollectionSection-template--24775760937293__16490846774bd46087 .section-header__link').attr('href',pre_lang+'/collections/novedades');
});
/* Fin home */
/* Carruseles */
$(document).ready(function(){
  /* Populares */
  $('#shopify-section-template--24775760937293__featured-collections .new-grid').slick({
    infinite: true,
    slidesToShow: 7,
    slidesToScroll: 1,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  /* Populares B2B */
  $('#shopify-section-template--24775760937293__featured_collections_d4tCGW .new-grid').slick({
    infinite: true,
    slidesToShow: 7,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  /* + vendidos */
  $('#CollectionSection-template--24775760937293__1649430755ee5e194e .product-grid').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false, // asegurarse de que no centra el slide
          arrows: false, // opcional: para simplificar en móvil
          dots: true
        }
      }
    ]
  });
  /* + vendidos B2B */
  $('#CollectionSection-template--24775760937293__featured_collection_UVATkU .product-grid').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false, // asegurarse de que no centra el slide
          arrows: false, // opcional: para simplificar en móvil
          dots: true
        }
      }
    ]
  });
  $('#CollectionSection-template--24775760937293__featured-collection .product-grid').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false, // asegurarse de que no centra el slide
          arrows: false, // opcional: para simplificar en móvil
          dots: true
        }
      }
    ]
  });
  $('.distribuidores-container .carousel-track.es').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true // importante: mantener las flechas en móvil
        }
      }
    ]
  });
  $('.distribuidores-container .carousel-track.en').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true // importante: mantener las flechas en móvil
        }
      }
    ]
  });
  $('.distribuidores-container .carousel-track.pt').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true // importante: mantener las flechas en móvil
        }
      }
    ]
  });
  $('.distribuidores-container .carousel-track.de').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true // importante: mantener las flechas en móvil
        }
      }
    ]
  });
  $('#CollectionSection-template--24775760937293__16490846774bd46087 .product-grid').slick({
    /*infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true
        }
      }
    ]*/
   infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false, // asegurarse de que no centra el slide
          arrows: false, // opcional: para simplificar en móvil
          dots: true
        }
      }
    ]
  });

  /* Marcas BF */
  /*jQuery('.carrusel-logos-bf')
    .not('.slick-initialized')
    .slick({
      slidesToShow: 6,
      slidesToScroll: 6,
      infinite: true,
      arrows: true,
      dots: true,
      responsive: [
        {
          breakpoint: 1024, // tablet y <1024px
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 768, // móvil y <768px
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });*/
  /* Fin Marcas BF */
});
function toggleSlickCarousel($carousel) {
  if (window.innerWidth <= 768) {
    if (!$carousel.hasClass('slick-initialized')) {
      $carousel.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: true,
        dots:true
      });
      console.log("✅ Slick inicializado en:", $carousel.attr('class') || $carousel.attr('id'));
    }
  } else {
    if ($carousel.hasClass('slick-initialized')) {
      $carousel.slick('unslick');
      console.log("🔁 Slick destruido en:", $carousel.attr('class') || $carousel.attr('id'));
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const selectors = [
    '.product-recommendations .product-grid',
    '#RecentlyViewed-template--24775761822029__recently-viewed .product-grid'
  ];

  function buscarYActivarCarruseles() {
    selectors.forEach(selector => {
      const $carousel = $(selector);
      if ($carousel.length) {
        toggleSlickCarousel($carousel);
      }
    });
  }

  // Observar el DOM para detectar cuando aparecen los carruseles
  const observer = new MutationObserver(buscarYActivarCarruseles);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Ejecutar al iniciar por si ya están presentes
  buscarYActivarCarruseles();

  // También ejecutar al redimensionar
  window.addEventListener("resize", buscarYActivarCarruseles);
});
/* Fin carruseles */
/* Eliminar botones de add to cart en los upsells */
document.addEventListener("DOMContentLoaded", function () {
  if($('body.template-product').length > 0)
  {
    let intentos = 0;
    const maxIntentos = 20;

    let interval = setInterval(function () {
        intentos++;

        const shadowHost = document.querySelector("#aftersell-pdp-upsell");

        if (!shadowHost) {
            console.log(`❌ [${intentos}] #aftersell-pdp-upsell no encontrado aún.`);
        } else {
            const shadow = shadowHost.shadowRoot;

            if (!shadow) {
                console.log(`⏳ [${intentos}] ShadowRoot aún no disponible.`);
            } else {
                if(jQuery('html[lang="en"]').length > 0)
                {
                  const upsell_title=shadow.querySelector(".upsell-header");
                  jQuery(upsell_title).text('Pairs well with');
                }
                else if(jQuery('html[lang="pt-PT"]').length > 0)
                {
                  const upsell_title=shadow.querySelector(".upsell-header");
                  jQuery(upsell_title).text('Combina bem com');
                }
              
                const actions = shadow.querySelectorAll(".product-card-actions");

                if (actions.length > 0) {
                    actions.forEach(el => el.remove());
                    console.log(`✅ [${intentos}] Eliminados ${actions.length} elementos '.product-card-actions'.`);
                    clearInterval(interval);
                    return;
                } else {
                    console.log(`🔍 [${intentos}] ShadowRoot listo pero sin '.product-card-actions' todavía...`);
                }
            }
        }

        if (intentos >= maxIntentos) {
            console.warn("⛔ Se alcanzó el número máximo de intentos. Se detiene la comprobación.");
            clearInterval(interval);
        }
    }, 500); // Revisa cada 500ms → 20 intentos = 10 segundos
  }
});
document.addEventListener("DOMContentLoaded", function () {
  if($('body.template-product').length > 0)
  {
    let intentos = 0;
    const maxIntentos = 20;

    let interval = setInterval(function () {
        intentos++;

        const shadowHost = document.querySelector("#aftersell-pdp-upsell");

        if (!shadowHost) {
            console.log(`❌ [${intentos}] #aftersell-pdp-upsell no encontrado aún.`);
        } else {
            const shadow = shadowHost.shadowRoot;

            if (!shadow) {
                console.log(`⏳ [${intentos}] ShadowRoot aún no disponible.`);
            } else {
                const headings = shadow.querySelectorAll("h2, h4");

                if (headings.length > 0) {
                    headings.forEach(heading => {
                        const div = document.createElement("div");
                        div.innerHTML = heading.innerHTML;
                        div.className = heading.className;
                        div.style.cssText = heading.style.cssText;

                        [...heading.attributes].forEach(attr => {
                            if (attr.name !== "class" && attr.name !== "style") {
                                div.setAttribute(attr.name, attr.value);
                            }
                        });

                        heading.replaceWith(div);
                    });

                    console.log(`✅ [${intentos}] Reemplazados ${headings.length} <h2>/<h4> por <div>.`);
                    clearInterval(interval);
                    return;
                } else {
                    console.log(`🔍 [${intentos}] ShadowRoot listo pero sin <h2>/<h4> todavía...`);
                }
            }
        }

        if (intentos >= maxIntentos) {
            console.warn("⛔ Se alcanzó el número máximo de intentos. Se detiene la comprobación.");
            clearInterval(interval);
        }
    }, 500);
  }
});
/* Fin eliminar botones de add to cart en los upsells */
/* Cambios en páginas de colecciones */
$(document).ready(function(){
  if($('#shopify-section-template--24775760413005__faq_M4qz7J').length > 0 && $('.contenido-categ').length > 0)
  {
    var contenido_categ = $('.contenido-categ').last();
    contenido_categ.after($('#shopify-section-template--24775760413005__faq_M4qz7J'));
  }
});

/* Fin cambios en páginas de colecciones */
/* Black friday 2025 */
$(document).ready(function(){
  if($('html[lang="es"]').length > 0)
  {
    $('a.section-header__link[href="/collections/bf-moza-top"]').attr('href','https://simufy.com/collections/moza-black-friday');
    $('a.section-header__link[href="/collections/bf-simagic-top"]').attr('href','https://simufy.com/collections/simagic-black-friday');
    $('a.section-header__link[href="/collections/bf-conspit-top"]').attr('href','https://simufy.com/collections/conspit-black-friday');
    $('a.section-header__link[href="/collections/bf-bundles-top"]').attr('href','https://simufy.com/collections/black-friday-bundles');
    $('a.section-header__link[href="/collections/bf-volantes-top"]').attr('href','https://simufy.com/collections/black-friday-volantes');
    $('a.section-header__link[href="/collections/bf-pedales-top"]').attr('href','https://simufy.com/collections/black-friday-pedales');
    $('a.section-header__link[href="/collections/bf-cockpits-top"]').attr('href','https://simufy.com/collections/black-friday-cockpits');
    $('a.section-header__link[href="/collections/bf-asetek-top"]').attr('href','https://simufy.com/collections/asetek-black-friday');
    $('a.section-header__link[href="/collections/bf-fanatec-top"]').attr('href','https://simufy.com/collections/fanatec-black-friday');
  }
  else if($('html[lang="en"]').length > 0){
    $('a.section-header__link[href="/en/collections/bf-moza-top"]').attr('href','https://simufy.com/en/collections/moza-black-friday');
    $('a.section-header__link[href="/en/collections/bf-simagic-top"]').attr('href','https://simufy.com/en/collections/simagic-black-friday');
    $('a.section-header__link[href="/en/collections/bf-conspit-top"]').attr('href','https://simufy.com/en/collections/conspit-black-friday');
    $('a.section-header__link[href="/en/collections/bf-bundles-top"]').attr('href','https://simufy.com/en/collections/black-friday-bundles');
    $('a.section-header__link[href="/en/collections/bf-volantes-top"]').attr('href','https://simufy.com/en/collections/black-friday-volantes');
    $('a.section-header__link[href="/en/collections/bf-pedales-top"]').attr('href','https://simufy.com/en/collections/black-friday-pedales');
    $('a.section-header__link[href="/en/collections/bf-cockpits-top"]').attr('href','https://simufy.com/en/collections/black-friday-cockpits');
    $('a.section-header__link[href="/en/collections/bf-asetek-top"]').attr('href','https://simufy.com/en/collections/asetek-black-friday');
    $('a.section-header__link[href="/en/collections/bf-fanatec-top"]').attr('href','https://simufy.com/en/collections/fanatec-black-friday');
  }
  else if($('html[lang="pt-PT"]').length > 0){
    $('a.section-header__link[href="/pt/collections/bf-moza-top"]').attr('href','https://simufy.com/pt/collections/moza-black-friday');
    $('a.section-header__link[href="/pt/collections/bf-simagic-top"]').attr('href','https://simufy.com/pt/collections/simagic-black-friday');
    $('a.section-header__link[href="/pt/collections/bf-conspit-top"]').attr('href','https://simufy.com/pt/collections/conspit-black-friday');
    $('a.section-header__link[href="/pt/collections/bf-bundles-top"]').attr('href','https://simufy.com/pt/collections/black-friday-bundles');
    $('a.section-header__link[href="/pt/collections/bf-volantes-top"]').attr('href','https://simufy.com/pt/collections/black-friday-volantes');
    $('a.section-header__link[href="/pt/collections/bf-pedales-top"]').attr('href','https://simufy.com/pt/collections/black-friday-pedales');
    $('a.section-header__link[href="/pt/collections/bf-cockpits-top"]').attr('href','https://simufy.com/pt/collections/black-friday-cockpits');
    $('a.section-header__link[href="/pt/collections/bf-asetek-top"]').attr('href','https://simufy.com/pt/collections/asetek-black-friday');
    $('a.section-header__link[href="/pt/collections/bf-fanatec-top"]').attr('href','https://simufy.com/pt/collections/fanatec-black-friday');
  }
  else if($('html[lang="de"]').length > 0){
    $('a.section-header__link[href="/de/collections/bf-moza-top"]').attr('href','https://simufy.com/de/collections/moza-black-friday');
    $('a.section-header__link[href="/de/collections/bf-simagic-top"]').attr('href','https://simufy.com/de/collections/simagic-black-friday');
    $('a.section-header__link[href="/de/collections/bf-conspit-top"]').attr('href','https://simufy.com/de/collections/conspit-black-friday');
    $('a.section-header__link[href="/de/collections/bf-bundles-top"]').attr('href','https://simufy.com/de/collections/black-friday-bundles');
    $('a.section-header__link[href="/de/collections/bf-volantes-top"]').attr('href','https://simufy.com/de/collections/black-friday-volantes');
    $('a.section-header__link[href="/de/collections/bf-pedales-top"]').attr('href','https://simufy.com/de/collections/black-friday-pedales');
    $('a.section-header__link[href="/de/collections/bf-cockpits-top"]').attr('href','https://simufy.com/de/collections/black-friday-cockpits');
    $('a.section-header__link[href="/de/collections/bf-asetek-top"]').attr('href','https://simufy.com/de/collections/asetek-black-friday');
    $('a.section-header__link[href="/de/collections/bf-fanatec-top"]').attr('href','https://simufy.com/de/collections/fanatec-black-friday');
  }

  const ahora = new Date();
  const fechaObjetivo = new Date('2025-11-14T00:00:00');
  if (ahora >= fechaObjetivo)
  {
    $('#shopify-section-template--24775760314701__rich_text_CkDUqL').prependTo($('footer.site-footer'));
    $('#shopify-section-template--24775760314701__rich_text_CkDUqL *').css('color','#000');
  }

  if($('.main-content.black-friday').length > 0)
  {
    if($('html[lang="en"]').length > 0)
    {
      $('.custom-content .custom__item:nth-of-type(1) img').remove();
      $('.custom-content .custom__item:nth-of-type(1) .image-wrap').append("<img src='https://cdn.shopify.com/s/files/1/0635/7709/6450/files/BANNERS-SABELT-699_x_350_px-EN.png?v=1763647824' />");
      $('.custom-content .custom__item:nth-of-type(1) a').attr('href','https://simufy.com/en/collections/sabelt-black-friday');
      $('.custom-content .custom__item:nth-of-type(2) img').removeAttr("src");
      $('.custom-content .custom__item:nth-of-type(2) img').removeAttr("data-src");
      $('.custom-content .custom__item:nth-of-type(2) img').attr("src","https://cdn.shopify.com/s/files/1/0635/7709/6450/files/BANNERS-Simuladores-completos-699_x_350_px-EN.jpg?v=1763058991");
    }
    else if($('html[lang="pt-PT"]').length > 0)
    {
      $('.custom-content .custom__item:nth-of-type(1) img').remove();
      $('.custom-content .custom__item:nth-of-type(1) .image-wrap').append("<img src='https://cdn.shopify.com/s/files/1/0635/7709/6450/files/BANNERS-SABELT-699_x_350_px-PT.png?v=1763647824' />");
      $('.custom-content .custom__item:nth-of-type(1) a').attr('href','https://simufy.com/pt/collections/sabelt-black-friday');
      $('.custom-content .custom__item:nth-of-type(2) img').removeAttr("src");
      $('.custom-content .custom__item:nth-of-type(2) img').removeAttr("data-src");
      $('.custom-content .custom__item:nth-of-type(2) img').attr("src","https://cdn.shopify.com/s/files/1/0635/7709/6450/files/BANNERS-Simuladores-completos-699_x_350_px-PT.jpg?v=1763058991");
      $('.custom-content .custom__item:nth-of-type(2) a').attr('href','https://simufy.com/pt/collections/simulador-completo');
    }
    else if($('html[lang="de"]').length > 0)
    {
      $('.custom-content .custom__item:nth-of-type(1) img').remove();
      $('.custom-content .custom__item:nth-of-type(1) .image-wrap').append("<img src='https://cdn.shopify.com/s/files/1/0635/7709/6450/files/BANNERS-SABELT-699_x_350_px-DE.png?v=1763647824' />");
      $('.custom-content .custom__item:nth-of-type(1) a').attr('href','https://simufy.com/de/collections/sabelt-black-friday');
      $('.custom-content .custom__item:nth-of-type(2) img').removeAttr("src");
      $('.custom-content .custom__item:nth-of-type(2) img').removeAttr("data-src");
      $('.custom-content .custom__item:nth-of-type(2) img').attr("src","https://cdn.shopify.com/s/files/1/0635/7709/6450/files/BANNERS-Simuladores-completos-699_x_350_px-DE.jpg?v=1763058991");
      $('.custom-content .custom__item:nth-of-type(2) a').attr('href','https://simufy.com/de/collections/simulador-completo');
    }
  }
  if($('html[lang="pt-PT"]').length > 0 && $('#shopify-section-template--24775760347469__rich_text_ziEnNA').length > 0)
  {
    $('#shopify-section-template--24775760347469__rich_text_ziEnNA h2').remove();
    if($('.main-content.simagic-black-friday').length > 0)
    {
      $('#shopify-section-template--24775760347469__rich_text_ziEnNA .theme-block').append('<h2>Todos os produtos Simagic rebajados nos Black SimuDays</h2>');
    }
    else if($('.main-content.conspit-black-friday').length > 0)
    {
      $('#shopify-section-template--24775760347469__rich_text_ziEnNA .theme-block').append('<h2>Todos os produtos Conspit rebajados nos Black SimuDays</h2>');
    }
    else if($('.main-content.sabelt-black-friday').length > 0)
    {
      $('#shopify-section-template--24775760347469__rich_text_ziEnNA .theme-block').append('<h2>Todos os produtos Sabelt rebajados nos Black SimuDays</h2>');
    }
    else if($('.main-content.simlab-black-friday').length > 0)
    {
      $('#shopify-section-template--24775760347469__rich_text_ziEnNA .theme-block').append('<h2>Todos os produtos SIM-LAB rebajados nos Black SimuDays</h2>');
    }
    else if($('.main-content.black-friday-bundles').length > 0)
    {
      $('#shopify-section-template--24775760347469__rich_text_ziEnNA .theme-block').append('<h2>Todos os pacotes rebajados nos Black SimuDays</h2>');
    }
    else if($('.main-content.black-friday-volantes').length > 0)
    {
      $('#shopify-section-template--24775760347469__rich_text_ziEnNA .theme-block').append('<h2>Todos os babados rebajados nos Black SimuDays</h2>');
    }
    else if($('.main-content.black-friday-pedales').length > 0)
    {
      $('#shopify-section-template--24775760347469__rich_text_ziEnNA .theme-block').append('<h2>Todos os pedais rebajados nos Black SimuDays</h2>');
    }
    else if($('.main-content.black-friday-cockpits').length > 0)
    {
      $('#shopify-section-template--24775760347469__rich_text_ziEnNA .theme-block').append('<h2>Todos os cockpits rebajados nos Black SimuDays</h2>');
    }
    else if($('.main-content.black-friday-bases-direct-drive').length > 0)
    {
      $('#shopify-section-template--24775760347469__rich_text_ziEnNA .theme-block').append('<h2>Todas as bases direct drive rebajadas nos Black SimuDays</h2>');
    }
    else if($('.main-content.black-friday-shifters').length > 0)
    {
      $('#shopify-section-template--24775760347469__rich_text_ziEnNA .theme-block').append('<h2>Todos os Travões e shifters rebajados nos Black SimuDays</h2>');
    }
    else
    {
      $('#shopify-section-template--24775760347469__rich_text_ziEnNA .theme-block').append('<h2>Todos os produtos MOZA rebajados nos Black SimuDays</h2>');
    }
  }
  if($('.main-content.black-friday').length > 0)
  {
    $('.newsletter-banner + .footer__section').css('padding','50px 0');
  }

  if($('.black-friday-header').length > 0 &&
    window.location.href !== "https://simufy.com/collections/black-friday" && 
    window.location.href !== "https://simufy.com/en/collections/black-friday" && 
    window.location.href !== "https://simufy.com/pt/collections/black-friday" && 
    window.location.href !== "https://simufy.com/de/collections/black-friday")
  {
    $('.newsletter_container .footer__newsletter').appendTo('.newsletter-banner + .footer__section .page-width');
    $('.newsletter-banner + .footer__section .page-width').attr('style','padding:50px 0 !important;');
    $('.newsletter_container').remove();
    $('.footer__newsletter, .footer__subscribe *').css('color','#fff')
  }

  if($('#shopify-section-template--24775760314701__rich_text_Awt9hA').length > 0)
  {
    var params = new URLSearchParams(window.location.search);

    if (params.has('page') || params.has('sort_by')) {

        var targetSelector = '#shopify-section-template--24775760314701__rich_text_Awt9hA';

        function instantScroll(attempt) {
            attempt = attempt || 1;

            var $target = jQuery(targetSelector);

            if (!$target.length) {
                // Reintentos si Shopify aún no ha inyectado la sección
                if (attempt < 15) {
                    setTimeout(function() {
                        instantScroll(attempt + 1);
                    }, 200);
                }
                return;
            }

            var top = $target.offset().top;

            // Scroll instantáneo
            window.scrollTo(0, top);

            // Fallback por si otro script vuelve a movernos
            setTimeout(function() {
                if (Math.abs(jQuery(window).scrollTop() - top) > 5) {
                    window.scrollTo(0, top);
                }
            }, 400);
        }

        // Disparamos tras DOM ready con un leve delay
        setTimeout(function() {
            instantScroll(1);
        }, 200);
    }
  }
});
/* Fin Black friday 2025 */
/* Navidad 2025 */
$(document).ready(function(){
  if(jQuery('#shopify-section-template--26703570567501__rich_text_CkDUqL').length > 0)
  {
    jQuery('.footer__section--border').first().after(jQuery('#shopify-section-template--26703570567501__rich_text_CkDUqL'));
  }
});
/* Fin Navidad 2025 */

/* Funcionalidad ver más/ver menos */
jQuery(window).on('load', function () {
  var $ = jQuery;
  var maxHeight = 220; // <- altura máxima visible
  var extraSpace = 40; // <- píxeles extra para evitar cortes (ajustable)
  var texto_mostrar = 'Leer más';
  var texto_ocultar = 'Ocultar descripción';

  if (jQuery('html[lang="en"]').length > 0) {
    texto_mostrar = 'Read more';
    texto_ocultar = 'Hide description';
  }
  else if (jQuery('html[lang="pt-PT"]').length > 0) {
    texto_mostrar = 'Leia mais';
    texto_ocultar = 'Ocultar descrição';
  }
  else if (jQuery('html[lang="de"]').length > 0) {
    texto_mostrar = 'Mehr lesen';
    texto_ocultar = 'Beschreibung ausblenden';
  }

  function getRealHeight($el) {
    if (!$el.length || !$el[0]) {
      return 0;
    }
    return $el[0].scrollHeight;
  }

  function updateDescriptionHeight($description) {
    if (!$description.length) {
      return;
    }

    var realHeight = getRealHeight($description) + extraSpace;
    $description.attr('data-full-height', realHeight);

    if ($description.hasClass('is-expanded')) {
      $description.css('max-height', realHeight + 'px');
    }
  }

  $('.product_description').each(function () {
    var $description = $(this);

    if ($description.next('.product-description-toggle').length) {
      return;
    }

    var fullHeight = getRealHeight($description) + extraSpace;

    if (fullHeight <= maxHeight) {
      return;
    }

    $description
      .attr('data-full-height', fullHeight)
      .css('max-height', maxHeight + 'px')
      .addClass('is-collapsed');

    var $toggleButton = $('<button>', {
      class: 'product-description-toggle',
      text: texto_mostrar,
      type: 'button',
      'aria-expanded': 'false'
    });

    $description.after($toggleButton);

    $toggleButton.on('click', function () {
      var isExpanded = $description.hasClass('is-expanded');

      if (isExpanded) {
        $description
          .removeClass('is-expanded')
          .addClass('is-collapsed')
          .css('max-height', maxHeight + 'px');

        $toggleButton
          .text(texto_mostrar)
          .attr('aria-expanded', 'false');
      } else {
        updateDescriptionHeight($description);

        $description
          .removeClass('is-collapsed')
          .addClass('is-expanded')
          .css('max-height', $description.attr('data-full-height') + 'px');

        $toggleButton
          .text(texto_ocultar)
          .attr('aria-expanded', 'true');
      }
    });

    $description.find('img').on('load', function () {
      updateDescriptionHeight($description);
    });
  });

  $(document).on('click', '.product_description .trigger_accordion', function () {
    var $description = $(this).closest('.product_description');

    if (!$description.length) {
      return;
    }

    setTimeout(function () {
      updateDescriptionHeight($description);
    }, 350);
  });

  $(window).on('resize', function () {
    $('.product_description').each(function () {
      updateDescriptionHeight($(this));
    });
  });
});
/* Fin funcionalidad ver más/ver menos */

/* Garantía reacondicionados */
jQuery(document).ready(function($) {
    var titulo = $('.product-single__title').text();

    if (titulo.toLowerCase().includes('reacondicionado')) {
        $('.feature.garantia .feature-text').text('1 año de garantía');
    }
    
    if (titulo.toLowerCase().includes('refurbished')) {
        $('.feature.garantia .feature-text').text('1 year warranty');
    }
    
    if (titulo.toLowerCase().includes('reformado')) {
        $('.feature.garantia .feature-text').text('1 ano de garantia');
    }
    
    if (titulo.toLowerCase().includes('überholter')) {
        $('.feature.garantia .feature-text').text('1 Jahr Garantie');
    }
});
/* Fin garantía reacondicionados */


/* Arreglos cabecera */
jQuery(document).ready(function ($) {

  function cambiarIdiomas() {
    if ($(window).width() <= 768) {

      $('.multi-selectors__item .faux-select').css('padding-right','0');
      $('.multi-selectors__item .faux-select svg').remove();

      var $wrapper = $('.multi-selectors__item');

      var traducciones = {
        'Español': 'ESP',
        'English': 'ENG',
        'Português': 'PT',
        'Deutsch': 'DE'
      };

      $('.disclosure-list__label').each(function () {
        var texto = $(this).text().trim();

        if (traducciones[texto]) {
          $(this).text(traducciones[texto]);
        }
      });

      // Mostrar cuando ya está todo cambiado
      $wrapper.addClass('is-ready');
    }
  }

  cambiarIdiomas();

  // Por si se renderiza dinámicamente
  $(document).on('click', '[data-disclosure-toggle]', function () {
    setTimeout(cambiarIdiomas, 100);
  });

});
/* Fin arreglos cabecera */

/* add to cart sin redirección */
document.addEventListener('submit', function(event) {
  const form = event.target;

  if (!form.classList.contains('ajax-add-to-cart-form')) {
    return;
  }

  event.preventDefault();

  const texts = getAjaxCartTexts();

  const button = form.querySelector('button[type="submit"]');
  const originalButtonText = button.dataset.addToCartText || button.textContent.trim();

  button.dataset.ajaxProcessing = 'true';
  button.disabled = true;
  button.innerHTML = texts.adding;

  const formData = new FormData(form);

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData,
    headers: {
      'Accept': 'application/json'
    }
  })
    .then(function(response) {
      if (!response.ok) {
        throw new Error(texts.error);
      }

      return response.json();
    })
    .then(function(item) {
      button.innerHTML = texts.added;

      return fetch('/cart.js');
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(cart) {
      const cartCounters = document.querySelectorAll(
        '.cart-count, [data-cart-count], .cart-count-bubble span'
      );

      cartCounters.forEach(function(counter) {
        counter.textContent = cart.item_count;
      });

      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: {
          cart: cart
        }
      }));

      setTimeout(function() {
        delete button.dataset.ajaxProcessing;
        button.disabled = false;
        button.textContent = originalButtonText;
      }, 1200);
    })
    .catch(function(error) {
      console.error(error);

      button.innerHTML = texts.errorShort;

      setTimeout(function() {
        delete button.dataset.ajaxProcessing;
        button.disabled = false;
        button.textContent = originalButtonText;
      }, 1500);
    });
});


function getAjaxCartTexts() {
  const currentLang = getCurrentShopifyLang();

  const translations = {
    es: {
      adding: 'Añadiendo...',
      added: 'Añadido',
      error: 'Error al añadir al carrito',
      errorShort: 'Error'
    },
    en: {
      adding: 'Adding...',
      added: 'Added',
      error: 'Error adding to cart',
      errorShort: 'Error'
    },
    fr: {
      adding: 'Ajout...',
      added: 'Ajouté',
      error: 'Erreur lors de l’ajout au panier',
      errorShort: 'Erreur'
    },
    de: {
      adding: 'Wird hinzugefügt...',
      added: 'Hinzugefügt',
      error: 'Fehler beim Hinzufügen zum Warenkorb',
      errorShort: 'Fehler'
    },
    pt: {
      adding: 'A adicionar...',
      added: 'Adicionado',
      error: 'Erro ao adicionar ao carrinho',
      errorShort: 'Erro'
    }
  };

  return translations[currentLang] || translations.es;
}


function getCurrentShopifyLang() {
  let lang = '';

  if (window.Shopify && Shopify.locale) {
    lang = Shopify.locale;
  } else if (document.documentElement.lang) {
    lang = document.documentElement.lang;
  } else {
    lang = window.location.pathname.split('/')[1] || 'es';
  }

  lang = lang.toLowerCase();

  if (lang.startsWith('es')) return 'es';
  if (lang.startsWith('en')) return 'en';
  if (lang.startsWith('fr')) return 'fr';
  if (lang.startsWith('de')) return 'de';
  if (lang.startsWith('pt')) return 'pt';

  return 'es';
}

function convertPreorderButtonToLink(button) {
  if (!button || button.dataset.ajaxProcessing === 'true') {
    return;
  }

  const form = button.closest('.ajax-add-to-cart-form');

  if (!form) {
    return;
  }

  const addToCartText = button.dataset.addToCartText?.trim();
  const currentText = button.textContent.trim();
  const productUrl = form.dataset.productUrl;

  if (!addToCartText || !currentText || !productUrl) {
    return;
  }

  /*
   * Mientras el texto siga siendo "Añadir al carrito"
   * en el idioma actual, es un producto normal.
   */
  if (currentText === addToCartText) {
    return;
  }

  /*
   * No interpretar como preorder los textos temporales
   * de nuestro AJAX.
   */
  const ajaxTexts = getAjaxCartTexts();

  const temporaryTexts = [
    ajaxTexts.adding,
    ajaxTexts.added,
    ajaxTexts.errorShort
  ];

  if (temporaryTexts.includes(currentText)) {
    return;
  }

  /*
   * El módulo ha cambiado el texto del botón:
   * consideramos que es un producto en preorder.
   */
  const link = document.createElement('a');

  link.href = productUrl;
  link.className = button.className;
  link.classList.add('product-card-preorder-link','product-card-configurar-button');

  /*
   * El enlace debe decir siempre "Añadir al carrito"
   * en el idioma correspondiente.
   */
  link.textContent = addToCartText;

  /*
   * Sustituimos todo el formulario para que no pueda
   * ejecutarse ni el AJAX ni el submit del preorder.
   */
  form.replaceWith(link);
}


function checkPreorderButtons(context) {
  const scope = context || document;

  if (
    scope.nodeType === Node.ELEMENT_NODE &&
    scope.matches?.(
      '.ajax-add-to-cart-form button[name="add"][data-add-to-cart-text]'
    )
  ) {
    convertPreorderButtonToLink(scope);
  }

  scope.querySelectorAll?.(
    '.ajax-add-to-cart-form button[name="add"][data-add-to-cart-text]'
  ).forEach(function(button) {
    convertPreorderButtonToLink(button);
  });
}


let preorderObserverTimeout = null;

const preorderButtonObserver = new MutationObserver(function(mutations) {
  clearTimeout(preorderObserverTimeout);

  preorderObserverTimeout = setTimeout(function() {
    const buttonsToCheck = new Set();

    mutations.forEach(function(mutation) {
      const target =
        mutation.target.nodeType === Node.TEXT_NODE
          ? mutation.target.parentElement
          : mutation.target;

      const targetButton = target?.closest?.(
        '.ajax-add-to-cart-form button[name="add"][data-add-to-cart-text]'
      );

      if (targetButton) {
        buttonsToCheck.add(targetButton);
      }

      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType !== Node.ELEMENT_NODE) {
          return;
        }

        if (
          node.matches?.(
            '.ajax-add-to-cart-form button[name="add"][data-add-to-cart-text]'
          )
        ) {
          buttonsToCheck.add(node);
        }

        node.querySelectorAll?.(
          '.ajax-add-to-cart-form button[name="add"][data-add-to-cart-text]'
        ).forEach(function(button) {
          buttonsToCheck.add(button);
        });
      });
    });

    buttonsToCheck.forEach(function(button) {
      convertPreorderButtonToLink(button);
    });
  }, 100);
});


function initializePreorderLinks() {
  checkPreorderButtons(document);

  preorderButtonObserver.observe(document.body, {
    subtree: true,
    childList: true,
    characterData: true
  });

  /*
   * Revisión temporal porque algunas aplicaciones
   * cambian el botón unos segundos después de cargar.
   */
  let attempts = 0;

  const retryInterval = setInterval(function() {
    checkPreorderButtons(document);

    attempts += 1;

    if (attempts >= 20) {
      clearInterval(retryInterval);
    }
  }, 250);
}


if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializePreorderLinks);
} else {
  initializePreorderLinks();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeAddToCartTexts);
} /*else {
  initializeAddToCartTexts();
}*/
/* fin add to cart sin redirección */

/* Arreglo anclas */
document.addEventListener('click', function(e) {
  const link = e.target.closest('.simulacion-buttons a');

  if (!link) return;

  const href = link.getAttribute('href');

  if (!href || !href.startsWith('#')) return;

  const target = document.querySelector(href);

  if (!target) return;

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  target.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
}, true);
/* Fin arreglo anclas */

/* Botón de compra sticky */
function initStickyProductCta() {

  if (!document.body.classList.contains('template-product')) {
    return;
  }

  const stickyBar = document.querySelector(
    '[data-sticky-product-cta]'
  );

  const stickyButton = stickyBar?.querySelector(
    '[data-sticky-product-button]'
  );

  const stickyButtonText = stickyBar?.querySelector(
    '[data-sticky-product-button-text]'
  );

  const stickyPrice = stickyBar.querySelector(
    '.sticky-product-cta__price'
  );

  const stickyOptions = stickyBar.querySelector(
    '[data-sticky-product-options]'
  );

  function syncStickyPrice() {
    const mainPrice = document.querySelector(
      '.product-block--price [data-product-price]'
    );

    if (!mainPrice || !stickyPrice) {
      return;
    }

    const visiblePrice =
      mainPrice.querySelector('[aria-hidden="true"]');

    stickyPrice.textContent = visiblePrice
      ? visiblePrice.textContent.trim()
      : mainPrice.textContent.trim();
  }

  function syncStickyOptions() {
    if (!stickyOptions) {
      return;
    }

    const selectedOptions = [];

    document
      .querySelectorAll('.variant-wrapper select[data-variant-input]')
      .forEach(function (select) {
        const wrapper = select.closest('.variant-wrapper');
        const label = wrapper?.querySelector('.variant__label');

        const optionName = label
          ? label.textContent.trim()
          : '';

        const optionValue =
          select.options[select.selectedIndex]?.text?.trim() || '';

        if (optionValue) {
          selectedOptions.push(
            optionName
              ? optionName + ': ' + optionValue
              : optionValue
          );
        }
      });

    stickyOptions.textContent = selectedOptions.join(' · ');
  }

  document.addEventListener('change', function (event) {
    if (
      event.target.matches(
        'select[data-variant-input], input[data-variant-input]'
      )
    ) {
      syncStickyOptions();
    }
  });

  function updateSticky() {
    syncStickyButton();
    syncStickyPrice();
    syncStickyOptions();
    updateStickyVisibility();
  }

  if (!stickyBar || !stickyButton || !stickyButtonText) {
    return;
  }

  let currentMainButton = null;
  let buttonObserver = null;
  let priceObserver = null;
  let currentMainPrice = null;
  let scrollTicking = false;

  function getMainButton() {
    const originalButton = document.querySelector(
      '[data-main-product-cta]'
    );

    if (!originalButton) {
      return null;
    }

    const mainForm = originalButton.closest('form');

    if (!mainForm) {
      return originalButton;
    }

    const preorderButton = mainForm.querySelector(
      '.gPreorderBtn:not(.gPreorderHidden)'
    );

    if (
      preorderButton &&
      preorderButton.offsetWidth > 0 &&
      preorderButton.offsetHeight > 0
    ) {
      return preorderButton;
    }

    if (
      originalButton.offsetWidth > 0 &&
      originalButton.offsetHeight > 0
    ) {
      return originalButton;
    }

    return null;
  }

  function observeCurrentPrice() {
    const mainPrice = document.querySelector(
      '.product-block--price [data-product-price]'
    );

    if (!mainPrice || mainPrice === currentMainPrice) {
      return;
    }

    currentMainPrice = mainPrice;

    if (priceObserver) {
      priceObserver.disconnect();
    }

    priceObserver = new MutationObserver(function () {
      syncStickyPrice();
    });

    priceObserver.observe(mainPrice, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    });

    syncStickyPrice();
  }

  function hideSticky() {
    stickyBar.classList.remove('is-visible');
    stickyBar.setAttribute('aria-hidden', 'true');
  }

  function syncStickyButton() {
    const mainButton = getMainButton();

    if (!mainButton) {
      hideSticky();
      return;
    }

    const mainButtonText = mainButton.querySelector(
      '[data-add-to-cart-text]'
    );

    stickyButtonText.textContent = mainButtonText
      ? mainButtonText.textContent.trim()
      : mainButton.textContent.trim();

    stickyButton.setAttribute(
      'aria-label',
      stickyButtonText.textContent.trim()
    );

    stickyButton.disabled = mainButton.disabled;
  }

  function updateStickyVisibility() {
    const mainButton = getMainButton();

    if (!mainButton) {
      hideSticky();
      return;
    }

    const buttonPosition = mainButton.getBoundingClientRect();
    const isVisible =
      mainButton.offsetWidth > 0 &&
      mainButton.offsetHeight > 0 &&
      getComputedStyle(mainButton).display !== 'none';

    const shouldShow =
      isVisible &&
      buttonPosition.bottom < 0;

    stickyBar.classList.toggle('is-visible', shouldShow);

    stickyBar.setAttribute(
      'aria-hidden',
      shouldShow ? 'false' : 'true'
    );

    updateChatPosition(shouldShow);
  }

  let chatContainer = null;
  let originalChatBottom = null;
  let originalChatBottomPriority = '';

  function findChatContainer() {
    if (chatContainer?.isConnected) {
      return chatContainer;
    }

    const elements = document.querySelectorAll('*');

    for (const element of elements) {
      if (!element.shadowRoot) {
        continue;
      }

      const container = element.shadowRoot.querySelector(
        '#widget-chat-container'
      );

      if (container) {
        chatContainer = container;

        originalChatBottom = container.style.getPropertyValue(
          'bottom'
        );

        originalChatBottomPriority =
          container.style.getPropertyPriority('bottom');

        return chatContainer;
      }
    }

    return null;
  }

  function updateChatPosition(stickyIsVisible) {
    const isMobile = window.matchMedia(
      '(max-width: 749px)'
    ).matches;

    const container = findChatContainer();

    if (!container) {
      return;
    }

    if (isMobile && stickyIsVisible) {
      container.style.setProperty(
        'bottom',
        '100px',
        'important'
      );

      return;
    }

    if (originalChatBottom) {
      container.style.setProperty(
        'bottom',
        originalChatBottom,
        originalChatBottomPriority
      );
    } else {
      container.style.removeProperty('bottom');
    }
  }

  function observeCurrentButton() {
    const mainButton = getMainButton();

    if (!mainButton || mainButton === currentMainButton) {
      return;
    }

    currentMainButton = mainButton;

    if (buttonObserver) {
      buttonObserver.disconnect();
    }

    buttonObserver = new MutationObserver(function () {
      syncStickyButton();
      updateStickyVisibility();
    });

    buttonObserver.observe(mainButton, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    });

    syncStickyButton();
    updateStickyVisibility();
  }

  stickyButton.addEventListener('click', function () {
    const mainButton = getMainButton();

    if (!mainButton || mainButton.disabled) {
      return;
    }

    mainButton.click();
  });

  window.addEventListener(
    'scroll',
    function () {
      if (scrollTicking) {
        return;
      }

      scrollTicking = true;

      window.requestAnimationFrame(function () {
        observeCurrentButton();
        updateStickyVisibility();
        scrollTicking = false;
      });
    },
    {
      passive: true
    }
  );

  window.addEventListener('resize', function () {
    updateStickyVisibility();

    updateChatPosition(
      stickyBar.classList.contains('is-visible')
    );
  });

  observeCurrentButton();
  observeCurrentPrice();
  syncStickyOptions();

  setTimeout(function () {
    observeCurrentButton();
    observeCurrentPrice();
  }, 500);

  setTimeout(function () {
    observeCurrentButton();
    observeCurrentPrice();
  }, 1500);

  setTimeout(function () {
    observeCurrentButton();
    observeCurrentPrice();
  }, 3000);
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initStickyProductCta
  );
} else {
  initStickyProductCta();
}
/* Fin botón de compra sticky */